import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {setSetting} from "./service";
function receiveMessage(e) {
  if(e.data.setting) {
    setSetting(e.data.setting)
  }
}
window.addEventListener("message", receiveMessage, false);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
